import { Exception } from '@awesome-nodes/object';
export class InjectionFactoryException extends Exception {
  constructor(message, messageTemplateValues, parent) {
    super(message, messageTemplateValues, parent);
    InjectionFactoryException.setPrototype(this);
  }

}
